export default __webpack_public_path__ + "static/media/billboard.d9dc7f84.png";